module.exports = __webpack_public_path__ + "static/media/thevoice.54457546.svg";